<template>
  <validation-observer
    id="stepIntroForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <vvs-input
      name="Ticaret Ünvanı"
      label="1. Ticaret Ünvanı"
      placeholder="Şahıs şirketleri Adı Soyadı'yı giriniz"
      validate="required|withoutEmoji|max:255"
      v-model="form.taxInfo.officialName"
    ></vvs-input>

    <vvs-input
      name="Vergi Kimlik No."
      label="2. Vergi Kimlik No."
      placeholder="Şahıs şirketleri TCKN'yi giriniz"
      validate="required|numeric|min:10|max:11|tinOrTcNumber"
      maxlength="11"
      v-model="form.taxInfo.tin"
    ></vvs-input>

    <vvs-input
      name="3. Vergi Dairesi"
      label="3. Vergi Dairesi"
      placeholder="Vergi lehvasında bulunan Vergi Dairesi'ni giriniz"
      validate="required|withoutEmoji|min:2|max:100"
      v-model="form.taxInfo.taxOffice"
    ></vvs-input>

    <vvs-input
      type="url"
      name="Firma Web Sitesi"
      label="4. Firma Web Sitesi"
      placeholder="Örnek: http(s)://ornekwebsitesi.com"
      validate="url|withoutEmoji"
      v-model="form.webSiteUrl"
    ></vvs-input>

    <vvs-address
      label="5. Adres Bilgilerini Giriniz"
      :address.sync="form.addresses[0]"
    ></vvs-address>

    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="İLERİ &gt;"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepCompanyInformation',
  mixins: [stepsMixin],
};
</script>
